import React, {useState,useEffect,useContext} from 'react';
import {CardPerso,Loading} from '@gull'
import { useTranslate } from 'react-redux-multilingual'
import { useForm, useFieldArray } from "react-hook-form";
import {scrollManager} from './scrollManagement/scrollManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { IsAuthContext } from 'app/App';
import axios from 'axios'
import swal from "sweetalert2";

const ExportComptableMain = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const { register, control, handleSubmit,formState: { errors }} = useForm({shouldFocusError:false});
    const [validButton,setValidButton] = useState(false)
    const [associateData,setAssociateData] = useState({})
    const [associateDataTaxe,setAssociateDataTaxe] = useState({})
    const [associateDataAcompte,setAssociateDataAcompte] = useState({})
    const [timer,setTimer]=useState({});
    const [currentTimer,setCurrentTimer]=useState(false);
    const [selectDatas,setSelectDatas]=useState(props.datas);

    const [exportHeadOnFlatFile,setExportHeadOnFlatFile] = useState(false)
    
    const { fields: columnHeader, append: appendColumnHeader, remove: removeColumnHeader } = useFieldArray({
        control,
        name: "columnHeader"
    });

    useEffect(() => {
        scrollManager(window.screen.width,columnHeader.length)
    }, [window.screen.width,columnHeader.length]);

    const stopLoading = () => {
        props.setLoading(false)
    };

    useEffect(function () {
        setSelectDatas(props.datas)
    }, [props.datas])
    
    useEffect(function () {
        if(currentTimer!=false){
            clearTimeout(timer[currentTimer]) 
        }
        setExportHeadOnFlatFile(false)
        setCurrentTimer(Date.now());
        removeColumnHeader(columnHeader.map((_, index) => index));

        if(props.detailConfig){
            setExportHeadOnFlatFile(props.detailConfig.config.export_header ? props.detailConfig.config.export_header : false)

            if(props.isFor=='other') props.setSelectionVentilation(props.detailConfig.config.ventilation)

            if(props.relanceConstructionCol || props.isFor!='other'){
                /*
                    Ici on reformate les données, pour qu'elles soient bien interprétées par ExportComtableMain
                    Pour les tiers client et tiers fournisseur, datas est un array alors que pour les ventes et acaht c'est un objet qui contient des fois d'autre objets 
                */
                let formateDatasObj = {}
                Object.entries(props.detailConfig.config.datas).map(([keyData,index])=>{
                    if(keyData!='mode_paiement' && keyData!='taxe' && keyData!='article' && keyData!='acompte'  && keyData!='general'){
                        formateDatasObj[index] = keyData
                    }else if(keyData=='mode_paiement'){
                        if(index.hasOwnProperty('numero')){ 
                            formateDatasObj[index.numero] = 'paymentNumber'
                        }
                        if(index.hasOwnProperty('libelle')){ 
                            formateDatasObj[index.libelle] = 'paymentWording'
                        }
                    }else if(keyData=='general'){
                        if(index.hasOwnProperty('numero')){ 
                            formateDatasObj[index.numero] = 'generalNumero'
                        }
                        if(index.hasOwnProperty('libelle')){ 
                            formateDatasObj[index.libelle] = 'generalLibelle'
                        }
                    }else if(keyData=='taxe' || keyData=='article'){
                        let objTaxe = {}
                        if(index.hasOwnProperty('numero')){ 
                            objTaxe[index.numero] = 'taxeNumber'
                        }
                        if(index.hasOwnProperty('libelle')){ 
                            objTaxe[index.libelle] = 'taxeWording'
                        }

                        if(Object.keys(objTaxe).length!=0) setAssociateDataTaxe(objTaxe)
                    }else if(keyData=='acompte' && props.typeExport!='achat_b2b'){
                        let objAcompte = {}
                        if(index.hasOwnProperty('numero')){ 
                            objAcompte[index.numero] = 'acompteNumber'
                        }
                        if(index.hasOwnProperty('libelle')){ 
                            objAcompte[index.libelle] = 'acompteWording'
                        }

                        if(Object.keys(objAcompte).length!=0) setAssociateDataAcompte(objAcompte)
                    }
                })
                props.detailConfig.config.header.map((value,ind)=>{
                    appendColumnHeader({ name: value});
                })
                if(Object.keys(formateDatasObj).length!=0) setAssociateData(formateDatasObj)
                if(props.isFor=='other'){
                    let tempTimer = setTimeout(() => {
                        stopLoading()
                    }, 1100)
                    setTimer({...timer,[Date.now()]:tempTimer}) 
                }
            }
        }else if(props.isFor=='other'){
            //Si il n'y a pas de config sur les ventes et achats, on réinitialise toute la vue
            props.setSelectionVentilation([])
            removeColumnHeader(columnHeader.map((_, index) => index));
            setAssociateData({})
            setAssociateDataTaxe({})
            setAssociateDataAcompte({})
            
            let tempTimer = setTimeout(() => {
                stopLoading()
            }, 1100)
            setTimer({...timer,[Date.now()]:tempTimer})      
        }
    }, [props.detailConfig,props.relanceConstructionCol,props.typeExport])

    const onSubmit = async (data) => {
        setValidButton(true)

        let axiosAction = props.detailConfig ? axios.put : axios.post
        let paramUrl = props.detailConfig ? '/'+props.detailConfig.id : ''

        let obj = {
            type:props.typeExport,
            config:{
                export_header:exportHeadOnFlatFile
            }
        }
        if(props.idCompany!='company') obj['other_company']=props.idCompany

        let header = []//les données pour les entetes 
        let linkDatas = {} //Pour les données associées
        
        data.columnHeader.map(value=>{
            let valeur = value.name == null ? '' : value.name
            header.push(valeur)
        })
        
        Object.entries(associateData).map(([index,dataField])=>{
            if(dataField=='paymentNumber' || dataField=='paymentWording'){
                let keyData = dataField=='paymentNumber' ? 'numero' : 'libelle'
                linkDatas.mode_paiement = {...linkDatas.mode_paiement,[keyData]:index}
            }else if(dataField=='generalNumero' || dataField=='generalLibelle'){
                let keyData = dataField=='generalNumero' ? 'numero' : 'libelle'
                linkDatas.general = {...linkDatas.general,[keyData]:index}
            }else{
                linkDatas[dataField] = index
            }
        })
        if(props.isFor=='other'){
            obj.config['ventilation'] = props.selectionVentilation
            Object.entries(associateDataTaxe).map(([associateIndexHeader,dataField])=>{
                let keyData = dataField=='taxeNumber' ? 'numero' : 'libelle'
                let keyTaxe = props.selectionVentilation.includes('taxe') ? 'taxe' : 'article'
                // let referenceIndexAssociateData = Object.entries(associateData).find(([ind,value])=> value==associateIndexHeader)
                linkDatas[keyTaxe] = {...linkDatas[keyTaxe],[keyData]:associateIndexHeader}
            })
            if(props.typeExport!='achat_b2b'){
                Object.entries(associateDataAcompte).map(([associateIndexHeader,dataField])=>{
                    let keyData = dataField=='acompteNumber' ? 'numero' : 'libelle'
                    linkDatas['acompte'] = {...linkDatas['acompte'],[keyData]:associateIndexHeader}
                })
            }
        }
        
        obj.config['header'] = header
        obj.config['datas'] = linkDatas

        const response = await axiosAction(process.env.REACT_APP_API_URL+"api/compta/compta_config"+paramUrl, obj
        ).then((response) => {
            setValidButton(false)
            // if(!props.detailConfig) props.setReload(Date.now())
            props.setReload(Date.now())
        }).catch((error) => {
            if(error=='end_session') return;
            if(error.response==undefined){
                swal.fire(t('unknowError'), "", "error");
            }
            else if(error.response.status==403){
                swal.fire(t('forbiddenGeneral'), "", "error");
            }
            else {
                swal.fire(t('unknowError'), "", "error");
            }
            setValidButton(false)
        })
    };

    const appendNewLine = () =>{
        appendColumnHeader({ name:"" })
    }

    const removeLine = (index) =>{
        removeColumnHeader(index)
        if(Object.keys(associateData).includes(index.toString())){
            setAssociateData(prevData => {
                //on reconstruie associateData si on retire une ligne, car il permet de ne pas afficher dans le select de chaque colonnes, les valeurs deja existante sur d'autre colonne
                let filteredData = Object.values(prevData).filter(value=>value!=associateData[index])
                let newdata = {}
                filteredData.map((item,ind)=> newdata[ind]=item )

                return newdata
            });
        }
        if(props.isFor=='other'){
            //Si la colonne qu'on supprime a une donnée associé TVA, on retire la ligne de donnée associée 
            if(associateDataTaxe.hasOwnProperty(index)){ //Object.keys(associateDataTaxe).includes(index)
                setAssociateDataTaxe(prevData => {
                    const newData = { ...prevData }; // Copier l'objet pour éviter les mutations directes
                    delete newData[index]; // Supprimer la clé
                    return newData; // Retourner le nouvel état mis à jour
                });
            }
            if(associateDataAcompte.hasOwnProperty(index)){ //Object.keys(associateDataAcompte).includes(index)
                setAssociateDataAcompte(prevData => {
                    const newData = { ...prevData }; // Copier l'objet pour éviter les mutations directes
                    delete newData[index]; // Supprimer la clé
                    return newData; // Retourner le nouvel état mis à jour
                });
            }
        }
    }

    const defineAssociateDateIndex = (e,index,selectName) => {
        if(selectName=='general'){
            if(e.target.value!=''){
                setAssociateData({...associateData,[index]:e.target.value})
            }else{
                if(Object.keys(associateData).includes(index.toString())){
                    setAssociateData(prevData => {
                        const newData = { ...prevData }; // Copier l'objet pour éviter les mutations directes
                        delete newData[index]; // Supprimer la clé
                        return newData; // Retourner le nouvel état mis à jour
                    });
                }
            }
        }else{
            //Dans le cas d'un changement de valeur poru le select de la taxe, index est la valeur selectionné de l'input de donnée associée de la même colonne 
            let funcAssociateData = (selectName=='taxe') ? setAssociateDataTaxe : setAssociateDataAcompte
            let variableAssociateData = (selectName=='taxe') ? associateDataTaxe : associateDataAcompte

            if(e.target.value!=''){
                funcAssociateData({...variableAssociateData,[index]:e.target.value})
            }else{
                if(Object.keys(variableAssociateData).includes(index.toString())){
                    funcAssociateData(prevData => {
                        const newData = { ...prevData }; // Copier l'objet pour éviter les mutations directes
                        delete newData[index]; // Supprimer la clé
                        return newData; // Retourner le nouvel état mis à jour
                    });
                }
            }
        }
    };

    return(<>
        {props.loading ? 
            <Loading />
        :
            <CardPerso header={
                <>
                    <span>{props.isFor=='client' ? t('exportConfigurationClient') : t('exportConfigurationFournisseur')}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={() => {
                            appendNewLine()
                        }}
                    >
                        {t('addColumn')}
                    </button>
                </>
            }>
                <div className="form-check form-switch mb-1">
                    <input checked={exportHeadOnFlatFile} type="checkbox" className="form-check-input" onChange={()=>setExportHeadOnFlatFile(!exportHeadOnFlatFile)} />
                    <label  className="form-check-label">{t('exportHeaderOnFlatFile')}</label>
                </div>
                <form 
                    onSubmit={handleSubmit(onSubmit)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target.type !== 'textarea') {
                            e.preventDefault();
                        }
                    }}
                >
                    <table
                        className="table table-bordered table-compta-export"
                    >
                        <thead>
                            <tr>
                                {columnHeader.map((value,index)=>{
                                    let numero = index+1
                                    return(
                                        <th key={index} scope="col form-group">
                                            <label className='d-flex justify-content-between'>
                                                {t('exportHeader')+' '+numero}
                                                {props.validButton ? 
                                                    <FontAwesomeIcon icon={faTrash} className='text-muted'/> 
                                                : 
                                                    <FontAwesomeIcon icon={faTrash} className='text-danger pointer' onClick={()=>removeLine(index)}/> 
                                                }
                                            </label>
                                            <input 
                                                disabled={validButton} 
                                                type="text" 
                                                className='form-control'
                                                name={`columnHeader[${index}].name`}
                                                defaultValue={`${value.name}`}
                                                {...register(`columnHeader.${index}.name`, {required:true})}
                                            />
                                            {errors.columnHeader?.[index]?.name && (
                                            <div className="text-danger mt-1 ml-2">
                                                {t('fieldRequired')}
                                            </div>
                                            )}
                                        </th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            <tr scope="col" >
                                {columnHeader.map((value,index)=>{
                                    let numero = index+1
                                    return(
                                        <td key={value.name+index} className='form-group position-relative'>
                                            <label>{t('associatedData')+' '+numero}</label>
                                            <select 
                                                disabled={validButton || props.reloading} 
                                                className='form-control mb-2' 
                                                value={associateData[index] ? associateData[index] : ''}
                                                onChange={(e)=>defineAssociateDateIndex(e,index,'general')}
                                            >
                                                <option value="">-- Select --</option>
                                                {selectDatas.map((dataField,ind)=>{
                                                    if( associateData[index]==dataField.data || !Object.values(associateData).includes(dataField.data)){
                                                        //On affiche la donnée dans le select que si elle n'a pas été attribuée à une colonne ou si on est sur la colonne sur laquelle elle est attribuée 
                                                        return(
                                                            <option key={dataField.data} value={dataField.data}>{
                                                                dataField.name
                                                            }</option>
                                                        )
                                                    }
                                                })}
                                            </select>
                                            {(props.isFor=='other') ?
                                                <>
                                                    {props.typeExport!='achat_b2b' &&
                                                        <div className="form-group">
                                                            <label>{t('associatedData')+' '+t('depositLabel')+' '+numero}</label>
                                                            <select 
                                                                disabled={validButton || props.reloading} 
                                                                value={associateDataAcompte[index] ? associateDataAcompte[index] : ''}
                                                                className='form-control' 
                                                                onChange={(e)=>defineAssociateDateIndex(e,index,'acompte')}
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {(!Object.values(associateDataAcompte).includes('acompteNumber') || associateDataAcompte[index]=='acompteNumber') ? 
                                                                    <option value="acompteNumber">{t('acompteNumber')}</option> 
                                                                : 
                                                                    false
                                                                }
                                                                {(!Object.values(associateDataAcompte).includes('acompteWording') || associateDataAcompte[index]=='acompteWording') ? 
                                                                    <option value="acompteWording">{t('acompteWording')}</option> 
                                                                : 
                                                                    false
                                                                }
                                                            </select>
                                                        </div>
                                                    }
                                                    {(props.selectionVentilation.includes('taxe') || props.selectionVentilation.includes('article')) ?
                                                        <div className="form-group">
                                                            <label>{t('associatedData')+' '+authParam.company.nomenclature_tgc+' '+numero}</label>
                                                            <select 
                                                                disabled={validButton || props.reloading} 
                                                                value={associateDataTaxe[index] ? associateDataTaxe[index] : ''}
                                                                className='form-control' 
                                                                onChange={(e)=>defineAssociateDateIndex(e,index,'taxe')}
                                                            >
                                                                <option value="">-- Select --</option>
                                                                {(!Object.values(associateDataTaxe).includes('taxeNumber') || associateDataTaxe[index]=='taxeNumber') ? 
                                                                    <option value="taxeNumber">{t('taxeNumber',{taxe:authParam.company.nomenclature_tgc})}</option> 
                                                                : 
                                                                    false
                                                                }
                                                                {(!Object.values(associateDataTaxe).includes('taxeWording') || associateDataTaxe[index]=='taxeWording') ? 
                                                                    <option value="taxeWording">{t('taxeWording',{taxe:authParam.company.nomenclature_tgc})}</option> 
                                                                : 
                                                                    false
                                                                }
                                                            </select>
                                                        </div>
                                                    : false
                                                    }
                                                </>
                                            :
                                                false
                                            }
                                            {props.reloading ? <div className="spinner-border spinner-border-sm" style={{position:"absolute", top:'28%'}}></div> : false}
                                        </td>
                                    )
                                })}
                            </tr>
                        
                        </tbody>
                    </table>

                    <button disabled={validButton} className='btn btn-primary mt-3'>
                        {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate')}
                    </button>
                </form>
            </CardPerso>
        }
    </>
    )
}

export default ExportComptableMain;